import { deleteTeam } from "api/Settings";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useDeleteTeam = (isBroker: boolean) => {
    const queryClient = useQueryClient();
    return useMutation(deleteTeam, {
        onSuccess: () => {
            queryClient.invalidateQueries('teams');
            queryClient.invalidateQueries(['widgetData', isBroker ? 'Data Sharing Brokers' : 'Data Sharing Teams']);
            toast.success("Deleted Successfully");
        },
        onError: () => {
            toast.error(`Something went wrong`);
        },
    });
};
